import React, { Component } from "react";
import { connect } from "react-redux";

import ButtonStrip from "../Layout/components/ButtonStrip";
import BoxButton from "../Layout/components/BoxButton";
import General from "./components/General";
import Aprobacion from "./components/Aprobacion";
import ModalCancel from "./components/ModalCancel";
import ModalAdicionarCenco from "./components/ModalAdicionarCenco";
import ModalAdicionarDetalle from "./components/ModalAdicionarDetalle";

import {
  getSolicitud,
  reiniciarEstado,
  showHideModalCancel,
  guardarSolicitud,
  completarSolicitud,
} from "./actions";

import {
  obtenerParametro,
  llamarMensajesAlerta,
} from "../NuevaSolicitud/actions";
import history from "../../utils/history";
import { showModalConfirmAction } from "../Layout/actions";
import { throws } from "assert";
import { toast } from "react-toastify";

const editableWhile = ["CREADA"];
const beforeCompleted = ["CREADA", "APROBADA"];

class Solicitud extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabs: [
        {
          id: 0,
          caption: "Solicitud",
          component: (prps) => <General {...prps} />,
        },
        {
          id: 1,
          caption: "Aprobación",
          component: (prps) => <Aprobacion {...prps} />,
        },
      ],
      selected: 0,
      horasCancelacion: undefined,
    };
  }

  componentWillMount() {
    if (this.props.match.params.id) {
      this.props.reiniciarEstado();
      this.props.getSolicitud(this.props.match.params.id);
    } else {
      history.push(`${window.FOLDER}/solicitudes`);
    }
  }

  componentDidMount() {
    this.props.obtenerParametro("HORAS_CANCELACION");
  }

  componentDidUpdate() {
    if (
      this.props.horasCancelacion !== undefined &&
      this.props.horasCancelacion.count > 0
    ) {
      this.state.horasCancelacion = this.props.horasCancelacion.toJS()[0].horasCancelacion;
    }
  }

  verifyCancel() {
    const horasCancelacion = this.state.horasCancelacion;
    const userInfo = this.props.user.toJS();
    const userRole = userInfo.roles[0].name;
    const currentDate = new Date();
    const dateEvent = new Date(this.props.fecha_hora_evento);
    dateEvent.setHours(dateEvent.getHours() - horasCancelacion);

    if (userRole.toLowerCase() == "solicitante") {
      if (currentDate < dateEvent) {
        this.props.showHideModalCancel(true);
      } else {
        this.props.llamarMensajesAlerta(
          `La solicitud no puede cancelarse, debido a que faltan menos de ${horasCancelacion} horas. Contacte a un administrador en caso de querer cancelar.`
        );
      }
    } else {
      this.props.showHideModalCancel(true);
    }
  }

  selectTab = (e, tab) => {
    e.preventDefault();
    if (tab === 1 && this.props.updated) {
      toast.info(
        "La solicitud a sido modificada, por favor, guarde los cambios para ingresar a esta área"
      );
    } else {
      this.setState({ selected: tab });
    }
  };

  componentWillUnmount() {}

  render() {
    const { tabs, selected } = this.state;
    if (!this.props.elementos) return null;
    const { user, estado } = this.props;
    const isSuOrAdmin = user
      .get("roles")
      .some((x) => x.get("name") === "su" || x.get("name") === "admin");
    const isEditable =
      (isSuOrAdmin && editableWhile.includes(estado)) ||
      editableWhile.includes(estado);

    const buttons = [];
    if (
      this.props.elementos.filter((x) => x === "HbXnYsZ3").count() &&
      isEditable
    ) {
      buttons.push(
        <BoxButton
          key={`action[0][0]`}
          name="floppy-o"
          onClick={(e) => this.props.guardarSolicitud()}
          title="Guardar"
        />
      );
    }
    if (
      this.props.elementos.filter((x) => x === "zVxZcf9L").count() &&
      beforeCompleted.includes(estado)
    ) {
      buttons.push(
        <BoxButton
          key={`action[0][1]`}
          name="ban"
          // onClick={(e) => this.props.showHideModalCancel(true)}
          onClick={(e) => this.verifyCancel()}
          title="Cancelar solicitud"
          html="Cancelar"
        />
      );
    }
    if (
      this.props.elementos.filter((x) => x === "z6cikfHN").count() &&
      estado === "APROBADA"
    ) {
      buttons.push(
        <BoxButton
          key={`action[0][2]`}
          name="check"
          onClick={(e) => {
            e.preventDefault();
            this.props.showModalConfirmAction(
              true,
              "Está seguro que desea marcar completada la solicitud?",
              () => this.props.completarSolicitud()
            );
          }}
          title="Cerrar solicitud"
        />
      );
    }

    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div style={{ height: "100%" }}>
          <div className="nav-container">
            <div className="nav-tabs-section">
              <ul className="nav-tabs-tabs">
                {tabs.map((x) => {
                  return (
                    <li
                      key={`li01[${x.id}]`}
                      className={selected === x.id ? "active" : ""}
                    >
                      <a onClick={(e) => this.selectTab(e, x.id)}>
                        {x.caption}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="nav-main-section">
              <div className="">
                <ButtonStrip actions={buttons} />
              </div>
              <div className="nav-main-section-scrollable">
                {tabs[selected].component({
                  isEditable,
                  isSuOrAdmin,
                })}
              </div>
            </div>
          </div>
        </div>
        <ModalCancel isEditable={isEditable} />
        <ModalAdicionarCenco isEditable={isEditable} />
        <ModalAdicionarDetalle isEditable={isEditable} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    elementos: state.layout.get("elementos"),
    estado: state.solicitud.get("estado"),
    user: state.signin.get("user"),
    updated: state.solicitud.get("updated"),
    horasCancelacion: state.nuevasolicitud.get("horas_cancelacion") || [],
    fecha_hora_evento: `${state.solicitud.get("fecha")} ${state.solicitud.get(
      "hora"
    )}`,
  };
}

const mapDispatchToProps = {
  reiniciarEstado,
  getSolicitud,
  showHideModalCancel,
  guardarSolicitud,
  completarSolicitud,
  obtenerParametro,
  llamarMensajesAlerta,
  showModalConfirmAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Solicitud);
